import { useState } from "react";
import s from "./MainFooterMobMenuCol.module.scss";
import AnimateHeight from "react-animate-height";
import ArrowDownIcon from "../../../../../Icons/ArrowDownIcon";
import { MainFooterMenu } from "../../MainFooterMenu";
import { FooterLink } from "../../../../types/MainFooterTypes";

interface Props {
  title: string;
  items: FooterLink[];
}

export const FooterMobMenuCol: React.FC<Props> = ({ title, items }) => {
  const [status, setStatus] = useState(false);
  const toggleClick = () => {
    setStatus(!status);
  };
  return (
    <div className={s.menu_wrapper}>
      <div className={s.menu}>
        <div className={s.menu_title}>
          <span>{title}</span>
        </div>
        <MainFooterMenu items={items} />
      </div>
      <div className={s.menu_mob}>
        <div className={s.menu_title} onClick={toggleClick}>
          <span>{title}</span>
          <ArrowDownIcon color="#7C7C81" />
        </div>
        <AnimateHeight duration={500} height={status ? "auto" : 0}>
          <MainFooterMenu items={items} />
        </AnimateHeight>
      </div>
    </div>
  );
};
